/**
 * ThemeCheckbox - ContactForm sözleşme alanındaki checkbox ile aynı stil
 * Tema ile uyumlu, biraz daha büyük checkbox (w-6 h-6)
 */

'use client'

import { motion } from 'framer-motion'

export interface ThemeCheckboxProps {
  id: string
  checked: boolean
  onChange: (checked: boolean) => void
  label: React.ReactNode
  className?: string
  labelClassName?: string
}

export default function ThemeCheckbox({
  id,
  checked,
  onChange,
  label,
  className = '',
  labelClassName = '',
}: ThemeCheckboxProps) {
  return (
    <motion.div
      className={`flex items-center gap-3 ${className}`}
      whileHover={{ x: 3 }}
      transition={{ type: 'spring' as const, stiffness: 300 }}
    >
      <input
        type="checkbox"
        id={id}
        className="hidden peer"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label
        htmlFor={id}
        className={`cursor-pointer flex items-center gap-3 peer-checked:[&_div]:bg-alsero-first peer-checked:[&_div]:shadow-tour-card peer-checked:[&_div]:border-alsero-first peer-checked:[&_svg]:opacity-100 ${labelClassName}`}
      >
        <motion.div
          className="bg-white w-6 h-6 p-1 flex justify-center items-center transition-colors duration-200 border border-[rgba(0,0,0,0.08)] rounded-sm flex-shrink-0"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <svg className="stroke-white opacity-0 transition-opacity duration-200" viewBox="0 0 14 14" fill="none">
            <path d="M3 8L6 11L11 3.5" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </motion.div>
        <span className="select-none text-alsero-dark-gray text-sm group-hover:text-alsero-first transition-colors">
          {label}
        </span>
      </label>
    </motion.div>
  )
}
